import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles/styles.css";
import "./styles/erp.css";
import "./styles/delta.css";
import "./styles/platform.css";
import "./styles/report-print.css";
import { LangProvider } from "./i18n";
import { SessionProvider } from "./lib/session";
import { ToastProvider } from "./components/Toast";
import { BelowCostProvider } from "./components/BelowCost";
import { App } from "./App";
import { captureAgentPairOffer } from "./lib/agent";

// A pairing code from Setup in the address (#agent-pair=…) leaves the address bar before anything else runs.
captureAgentPairOffer();

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <LangProvider>
      <BrowserRouter>
        <SessionProvider>
          <ToastProvider>
            <BelowCostProvider>
              <App />
            </BelowCostProvider>
          </ToastProvider>
        </SessionProvider>
      </BrowserRouter>
    </LangProvider>
  </StrictMode>
);
